
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum AccountingIntegrationType {
	BusinessCentral = 1,
	Economic = 2
}
export namespace AccountingIntegrationType {
	export function getKeys(): Map<AccountingIntegrationType, string> {
		return new Map([[1, 'BusinessCentral'], [2, 'Economic']]);
	}
}
